import { FC, ReactNode } from 'react';
import { DetailHeader } from 'components/Forms/DetailHeader';

type Props = {
  isNew: boolean;
  children: ReactNode;
};

const ignoreSave = () => undefined;

export const FilterDetailMessage: FC<Props> = ({ isNew, children }) => (
  <div className="content-full-width detail-form">
    <DetailHeader saveForm={ignoreSave} type="Filter" isNew={isNew} backTo="/filters" readOnly />
    <div className="card">
      <div className="card-body card-body-page-detail">{children}</div>
    </div>
  </div>
);
